import React from "react";

import { Switch } from "~/components/switch";
import { useScope } from "~/tools/impulse";

import type { WidgetConnectNulls } from "./form-state";

export interface WidgetVisualConnectNullsFieldProps {
	className?: string;
	name: string;
	connectNulls: WidgetConnectNulls;
}

export const WidgetConnectNullsField: React.FC<WidgetVisualConnectNullsFieldProps> = ({
	className,
	name,
	connectNulls,
}) => {
	const scope = useScope();

	return (
		<Switch
			checked={connectNulls.getInput(scope)}
			className={className}
			name={name}
			onCheckedChange={(show) => connectNulls.setInput(show)}
		/>
	);
};
